export default __webpack_public_path__ + "static/media/AddSchedule.dfe6e377.svg";